<div class="reservation-container">
    <div class="reservation-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Detail de réservations</span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <div class="reservation-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du réservation...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="btn-primary" (click)="goToList()">Retour à la liste</button>
        </div>

        <div *ngIf="!isLoading && reservation && !errorMessage" class="reservation-card-container">
            <div class="reservation-card-container">
                <div class="reservation-card">
                    <div class="reservation-image-col">
                        <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
                    </div>

                    <div class="reservation-content-col">
                        <div class="col-header">
                            <h3 class="reservation-title"><strong>{{ reservation.eventName }}</strong> / {{ reservation.client.firstName +" "+ reservation.client.lastName }}</h3>
                            <div class="right-side">
                                <div class="status-badge">
                                    <span class="status-dot" [ngClass]="getReservationAdminStatusClass()"></span>
                                    <span class="status-text">{{ getReservationAdminStatusText() }}</span>
                                </div>
                                <button *ngIf="canConfirmReservation()" class="action-btn confirm-btn" (click)="onConfirmReservation()">
                                    <img src="assets/images/icons/check-circle.svg" alt="check">
                                    <span>Confirmer</span>
                                </button>
                                <!--<button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                                    <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                                </button>-->
                            </div>
                        </div>

                        <div class="reservation-footer">
                            <div class="info-col">
                                <div class="data-row">
                                    <div class="data">
                                        <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon">
                                        <span><strong>Nombre d'agents requis : </strong> {{ reservation.requiredAgents }}</span>
                                    </div>
                                    <div class="data">
                                        <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon">
                                        <span><strong>Date d'événement : </strong> {{ reservation.startDateTime }} @if(reservation.endDateTime){- {{ reservation.endDateTime }} }</span>
                                    </div>
                                    <div class="data">
                                        <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon">
                                        <span><strong>Address d'événement : </strong> {{ formatAddress(reservation.address) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="creation-date">
                                {{ reservation.createdAt }}
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="popup-menu" *ngIf="menuOpen">
                    <div class="arrow"></div>
                    <ul>
                        <li>
                            <img src="./assets/images/icons/details.png" alt="View"> Details
                        </li>

                        <li (click)="confirmDelete()" class="delete-item">
                            <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
                        </li>
                    </ul>
                </div>-->

                <div class="description-card">
                    <h1>Note</h1>
                    <p>{{reservation.description}}</p>
                </div>

                <div class="offers-card">
                    <div class="offers-card-header">
                        <h1><img src="./assets/images/icons/suitcase.png" alt="suitcase">
                            <span>Offres <strong *ngIf="reservation.offers">({{ reservation.offers.length || '0' }})</strong></span>
                        </h1>
                        <button *ngIf="canCreateNewOffer() && reservation.offers" (click)="createNewOffer()" class="create-offer-btn"><img src="./assets/images/icons/suitcase.png" alt="suitcase"><span>Ajouter une offre</span></button>
                    </div>


                    <!-- Empty state -->
                    <div *ngIf="!reservation.offers || (reservation.offers && reservation.offers.length === 0)" class="empty-offer-state">
                        <p *ngIf="canCreateNewOffer()">Aucune proposition en cours. <span (click)="createNewOffer()">Cliquez</span> ici pour créer une offre.</p>
                        <p *ngIf="!canCreateNewOffer()">
                            Vous ne pouvez pas créer d'offre pour cette réservation en raison de son statut.
                        </p>
                    </div>

                    <!-- Offers list -->
                    <div *ngIf="reservation.offers && reservation.offers.length > 0" class="offers-list">
                        <app-admin-reservation-offer-card *ngFor="let offer of offersWithActions" [offer]="offer" [reservationId]="reservation.id" (offerDeleted)="onOfferdeleted($event)" (agentDeleted)="onAgentdeleted($event)"></app-admin-reservation-offer-card>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showConfirmModal" (click)="closeConfirmModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la reservation</h3>
            <button class="close-button" (click)="closeConfirmModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir confirmer cette reservation avec l'offer accepter par le client ?</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeConfirmModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmReservation()">Confirmer</button>
        </div>
    </div>
</div>